import { MatchSorterOptions, matchSorter } from "match-sorter"
import { ListProductData } from "src/data/product-list/types"

const matchSorterOptions: MatchSorterOptions<ListProductData> = {
  keys: [
    (item) => item.slug || "",
    (item) => item.sku || "",
    (item) => item.name,
    (item) => item.categories?.map((category) => category.name) || [],
    (item) => item.variations?.map((variation) => variation.sku) || [],
    (item) => item.variations?.map((variation) => variation.name) || [],
  ],
}

export function searchProducts(products: ListProductData[], value: string) {
  if (!value?.length) {
    return products
  }

  const terms = value.split(/[\s-]+/g).filter(Boolean)

  if (!terms) {
    return products
  }

  // https://github.com/kentcdodds/match-sorter?tab=readme-ov-file#match-many-words-across-multiple-fields-table-filtering
  return terms.reduceRight((results, term) => {
    return matchSorter(results, term, matchSorterOptions)
  }, products)
}
